import React from 'react';

const PetInfoInput = (props) => {
  const {petName, clinicRecordNumber, mealsPerDay, setPetName, setClinicRecordNumber, setMealsPerDay, openModalWithContent} = props;
  const {labels} = props.data;

  const handleKeyUp = event => {
    switch (event.target.dataset.type){
      case "setPetName":
        const sanitizedString = event.target.value.replace(/[^\p{L}`ʼ'\s-]/u, "");
        setPetName(sanitizedString);
        break;

      case "setClinicRecordNumber":
        setClinicRecordNumber(event.target.value);
        break;

      case "setMealsPerDay":
        setMealsPerDay(Math.abs(event.target.value));
        break;
    }
  };

  return (
    <>
      <div className="nppe2-fc-pets-info">
        <div className="row">

          <div className="col-xs-6">
            <div className="nppe2-fc-sub-title">
              {labels.petName}
            </div>
          </div>

          <div className="col-xs-6">
            <div className="nppe2-fc-sub-title">{labels.clinicRecordNumber}</div>
          </div>

        </div>

        <div className="row nppe2-fc-mt-0">

          <div className="col-xs-6">
            <input
              id="nppe2-fc-validate-pet-name"
              type="text"
              data-type="setPetName"
              onChange={handleKeyUp}
              aria-label={labels.petName}
              value={petName}
            >
            </input>

            <div className="nppe2-fc-sub-title">{labels.mealsPerDay}</div>

            <div className="nppe2-fc-meals-per-day-wrapper">
              <input
                type="number"
                defaultValue="2"
                value={(mealsPerDay === 0) ? 1 : mealsPerDay}
                min="1"
                max="24"
                step="1"
                data-type="setMealsPerDay"
                onChange={handleKeyUp}
                aria-label={labels.mealsPerDay}
              ></input>

              <a href="#" aria-label={labels.aria}>
                <div className="nppe2-fc-info-button"
                onClick={ (e) => {
                  props.openModalWithContent("MealsPerDay");
                  e.preventDefault();
                }}></div>
              </a>
            </div>

          </div>

          <div className="col-xs-6">
            <input
              type="text"
              data-type="setClinicRecordNumber"
              onChange={handleKeyUp}
              aria-label={labels.clinicRecordNumber}
              value={clinicRecordNumber}
            >
            </input>
          </div>

        </div>
      </div>
    </>
  )
}

export default PetInfoInput;
